import './ToastNotes.css';
import { useEffect, useState } from 'react';
import { ReactComponent as CLoseMark } from '../../resources/icon/close.svg';
import { ReactComponent as Issues } from '../../resources/icon/issues.svg';
import { ReactComponent as CheckIcon } from '../../resources/icon/CheckMark.svg';

export type ToastItem = {
    time: number;
    code?: string;
    message: string;
};

export type ToastProps = {
    type: 'error' | 'success';
    item: ToastItem;
    index: number;
    clearToast: Function;
};

const Toast = (props: ToastProps) => {
    return (
        <div className={props.type === 'error' ? 'Toast-note-box' : 'Toast-note-box--success'}>
            <CLoseMark
                onClick={() => {
                    props.clearToast(props.index);
                }}
                className='CloseToast'
            />
            <div className='Error-note-List'>
                <div className='Left-side'>
                    {props.type === 'error' ? (
                        <Issues className='Issues-Icon' />
                    ) : (
                        <CheckIcon className='Issues-Icon' />
                    )}
                </div>
                <div className='Right-side'>
                    <div className='Error-note-line-Box'>
                        {' '}
                        {props.item?.code
                            ? props.item?.message + ' (' + props.item?.code + ') '
                            : props.item?.message}
                    </div>
                </div>
            </div>
        </div>
    );
};

export type ToastNotesProps = {
    error?: Array<ToastItem>;
    successMsg?: Array<ToastItem>;
    clearToast: Function;
};

const ToastNotes = (props: ToastNotesProps) => {
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            if (
                (props?.error?.length && props.error) ||
                (props?.successMsg?.length && props.successMsg)
            ) {
                const nowTime = new Date().getTime();
                const errors = props?.error?.length ? props.error : [];
                const successMsgs = props?.successMsg?.length ? props.successMsg : [];
                const allMsgs = errors.concat(successMsgs);

                for (let u = 0; u < allMsgs.length; u++) {
                    const oneErr = allMsgs[u];
                    var secondBetweenTwoDate = Math.abs((nowTime - oneErr.time) / 1000);

                    if (secondBetweenTwoDate > 10) {
                        props.clearToast(u);
                    }
                }

                setCounter(nowTime);
            }
        }, 1000);
        return () => (timer ? clearInterval(timer) : undefined);
    }, [counter]);

    const haserrors = props?.error && props.error.length > 0 ? true : false;
    const hasSuccessMsgs = props?.successMsg && props.successMsg.length > 0 ? true : false;

    return (
        <div className='Toast-notes-Holder'>
            {haserrors &&
                props?.error?.map((item: ToastItem, index: any) => {
                    return (
                        <Toast
                            key={'toast-line-' + index}
                            clearToast={props.clearToast}
                            index={index}
                            item={item}
                            type={'error'}
                        />
                    );
                })}
            {hasSuccessMsgs &&
                props?.successMsg?.map((item: ToastItem, index: any) => {
                    return (
                        <Toast
                            key={'toast-line-' + index}
                            clearToast={props.clearToast}
                            index={index}
                            item={item}
                            type={'success'}
                        />
                    );
                })}
        </div>
    );
};

export default ToastNotes;
